import React, { useEffect } from 'react';
// import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { connect } from 'react-redux';
import Errors from '~/components/Errors/Errors';
import Layout from '~/components/Layouts/LayoutBasic/LayoutBasic';
import Breadcrumb from '~/components/institution/Breadcrumb/Breadcrumb';
import DownApp from '~/components/DownApp/DownApp';
import Card from '~/components/institution/Card/Card';
import ServiceProject from '~/components/institution/ServiceProject/ServiceProject';
import ServiceScore from '~/components/institution/ServiceScore/ServiceScore';
import Recommend from '~/components/institution/Recommend/Recommend';

import css from '~/styles/institution/institution.less';

const Institution = props => {
  useEffect(() => {
    const { query } = props;
    const id = parseInt(query.id, 10);
    if (!id) {
      window.location.href = '/';
    }
  }, []);

  const { institution, asPath } = props;
  const path = asPath.split('?')[0];
  const url = `${process.env.API_URL}${path}`;
  const { shop, status } = institution;
  const title = `${shop.name} - 新得宝贝` || '新得宝贝 - 母婴服务放心选';
  if (status !== 0) {
    return <Errors statusCode={404} />;
  }
  return (
    <Layout>
      <NextSeo
        title={title}
        description="新得宝贝 - 母婴服务放心选"
        canonical={url}
        openGraph={{
          type: 'product',
          url,
          title,
          images: [
            {
              url: shop.cover_url || '',
            },
          ],
          site_name: '新得宝贝',
        }}
      />
      <div className={css.contentMain}>
        <div className={css.main}>
          {/* 面包屑导航组件 */}
          <Breadcrumb />
          {/* 机构基础信息组件 */}
          <Card />
          {/* 服务项目列表 */}
          <ServiceProject />
          {/* 服务评分 */}
          <ServiceScore />
        </div>
        <div className={css.fixedQrcode}>
          {/* 右侧小程序二维码组件 */}
          <DownApp />
          {/* 右侧推荐机构列表 */}
          <Recommend />
        </div>
      </div>
    </Layout>
  );
};

Institution.getInitialProps = async ({ pathname, query, dvaStore, asPath }) => {
  // dispatch effects to fetch data here
  const id = parseInt(query.id, 10);
  if (id) {
    query.id = id;
    query.cid = parseInt(query.cid, 10) || '';
    query.type = parseInt(query.type, 10) || '';
    query.p = parseInt(query.p, 10) || 1;
    await dvaStore.dispatch({
      type: 'institution/init',
      payload: { ...query },
    });
    await dvaStore.dispatch({ type: 'institution/getShopDetail' });
    await dvaStore.dispatch({ type: 'institution/getRecommendList' });
    await dvaStore.dispatch({ type: 'institution/getProductList' });
    await dvaStore.dispatch({ type: 'institution/getCommentList' });
  }
  return {
    pathname,
    query,
    dvaStore,
    asPath,
  };
};

export default connect(({ institution }) => ({
  institution,
}))(Institution);
